/* eslint-disable prettier/prettier */
import { errorToast, successToast } from '@/utils/toaster';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { $http } from '../../../../plugins';
import { CabinetContext } from '../../context';
import { SET_STEP } from '../../context/types';
export default () => {
  const navigate = useNavigate();
  const {
    dispatch,
    state: { form, step, token }
  } = useContext(CabinetContext);
  const [isLoading, setIsLoading] = useState(false)
  const onSubmit = async () => {
    setIsLoading(true)
    const areaList = form?.areaList.map((area) => {
      return {
        areaId: area.areaId.value,
        fdtList: area.fdtList.map((fdtCode) => fdtCode.value),
        towersCount: Number(area.towersCount),
        subsCount: Number(area.subsCount),
        attachments: [
          {
            attachmentCode: area.MarketingPlan.attachmentCode,
            attachmentType: 'MarketingPlan'
          },
          {
            attachmentCode: area.DeploymentPlan.attachmentCode,
            attachmentType: 'DeploymentPlan'
          },
          {
            attachmentCode: area.MaintenancePlan.attachmentCode,
            attachmentType: 'MaintenancePlan'
          }
        ]
      };
    })

    $http
      .post(
        'Form/MarketingPlan/Create',
        {
          areaList
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        successToast();
        navigate('/done', { replace: true, state: { no: res.data.formNo } });
        setIsLoading(false)
      })
      .catch((err) => {
        errorToast();
        setIsLoading(false)
      })
  };
  const goBack = () => {
    dispatch({ type: SET_STEP, payload: step - 1 });
  };
  return { onSubmit, form, goBack, isLoading };
};
